// =============================================================================
// graficaModulo.js
// =============================================================================
import { mostrarToast } from './utilerias.js';

export class GestorGrafica {
    /**
     * @param {Object} config Configuración dinámica de IDs y almacenamiento
     */
    constructor(config) {
    this.config = {
        idInicio: config.idInicio || 'art-fecha-inicio',
        idFin: config.idFin || 'art-fecha-fin',
        idContenedorMetricas: config.idContenedorMetricas || 'lista-metricas-checkboxes',
        idCanvas: config.idCanvas || 'grafica-seleccionada',
        storageKey: config.storageKey || 'preferenciasGraficaArticulo',
        selectorCheckboxes: config.selectorCheckboxes || '.art-metrica-selector',

        // NUEVO
        posicionLeyenda: config.posicionLeyenda || 'top',
        onLegendChange: config.onLegendChange || null
    };

    this.datosGlobales = [];
    this.GraficaInstance = null;
}

    configurarModalGrafica(datos) {
        if (!datos || !Array.isArray(datos)) {
            mostrarToast('No hay datos para graficar.', 'warning');
            return; 
        }
        if (datos.length === 0) return;

        this.datosGlobales = datos;

        const nombresCampoUnicos = [...new Set(
             this.datosGlobales
                .map(item => item.nombre_campo)
                .filter(n => n && typeof n === 'string') 
        )];
        
        const anios = this.datosGlobales.map(item => item.anio);
        const minAnio = Math.min(...anios);
        const maxAnio = Math.max(...anios);

        const inputInicio = document.getElementById(this.config.idInicio);
        const inputFin = document.getElementById(this.config.idFin);
        const contenedorMetricas = document.getElementById(this.config.idContenedorMetricas);

        const guardado = JSON.parse(localStorage.getItem(this.config.storageKey)) || { metricas: [], fechaInicio: '', fechaFin: '' };

        if (inputInicio) inputInicio.value = guardado.fechaInicio || `${minAnio}-01`; 
        if (inputFin) inputFin.value = guardado.fechaFin || `${maxAnio}-12`;
        
        const concepts = [...new Set(nombresCampoUnicos.map(n => {
            const textoSeguro = n ? String(n) : ""; 
            return textoSeguro.replace(' Promedio', '').replace(' Real', '').trim();
        }))];

        let ultimoTabla = null;

        if (contenedorMetricas) {
            contenedorMetricas.innerHTML = concepts.map((concepto, index) => {
                const datoOriginal = this.datosGlobales.find(d => {
                    const textoSeguro = d.nombre_campo ? String(d.nombre_campo) : "";
                    return textoSeguro.replace(' Promedio', '').replace(' Real', '').trim() === concepto;
                });

                const valorTabla = datoOriginal ? datoOriginal.tabla : null;
                let html = '';
                
                if (ultimoTabla !== null && valorTabla !== ultimoTabla) {
                    html += `<div class="row mb-3"><div class="col-12" style="height: 25px; border-bottom: 2px solid #dee2e6;"></div></div>`;
                }
                
                ultimoTabla = valorTabla;

                const nombrePromedio = `${concepto} Promedio`;
                const nombreReal = `${concepto} Real`;
                const checkProm = guardado.metricas.includes(nombrePromedio) ? 'checked' : '';
                const checkReal = guardado.metricas.includes(nombreReal) ? 'checked' : '';

                return html + `
                    <div class="row align-items-center mb-2 border-bottom pb-1">
                        <div class="col-6"><span class="fw-bold text-secondary" style="font-size: 0.9rem;">${concepto}</span></div>
                        <div class="col-3 text-center">
                            <div class="form-check d-inline-block">
                                <input class="form-check-input ${this.config.selectorCheckboxes.replace('.', '')}" type="checkbox" value="${nombrePromedio}" id="check-${nombrePromedio}" ${checkProm}>
                                <label class="form-check-label small" for="check-${nombrePromedio}"></label>
                            </div>
                        </div>
                        <div class="col-3 text-center">
                            <div class="form-check d-inline-block">
                                <input class="form-check-input ${this.config.selectorCheckboxes.replace('.', '')}" type="checkbox" value="${nombreReal}" id="check-${nombreReal}" ${checkReal}>
                                <label class="form-check-label small" for="check-${nombreReal}"></label>
                            </div>
                        </div>
                    </div>`;
            }).join('');
        }

        this.verificarYDibujarGrafica(minAnio, maxAnio);
    }

    verificarYDibujarGrafica(min, max) {
        const guardado = JSON.parse(localStorage.getItem(this.config.storageKey));
        const inputInicio = document.getElementById(this.config.idInicio);
        const inputFin = document.getElementById(this.config.idFin);

        if (guardado) {
            if (guardado.fechaInicio && inputInicio) inputInicio.value = guardado.fechaInicio;
            if (guardado.fechaFin && inputFin) inputFin.value = guardado.fechaFin;
            
            if (guardado.metricas && guardado.metricas.length > 0) {
                setTimeout(() => {
                    this.generarGraficaArts();
                }, 400);
            }
        } else if (min && max) {
            if (inputInicio) inputInicio.value = `${min}-01`;
            if (inputFin) inputFin.value = `${max}-12`;
        }
    }

    generarGraficaArts() {
        const fechaInicioStr = document.getElementById(this.config.idInicio).value;
        const fechaFinStr = document.getElementById(this.config.idFin).value;
        const metricasSeleccionadas = Array.from(document.querySelectorAll(`${this.config.selectorCheckboxes}:checked`)).map(cb => cb.value);

        if (!fechaInicioStr || !fechaFinStr || metricasSeleccionadas.length === 0) {
            mostrarToast('Selecciona un rango de fechas y al menos una métrica.', 'warning');
            return;
        }

        const [anioI, mesI] = fechaInicioStr.split('-').map(Number);
        const [anioF, mesF] = fechaFinStr.split('-').map(Number);

        const fechaInicio = new Date(anioI, mesI - 1, 1);
        const fechaFin = new Date(anioF, mesF - 1, 1);

        if (fechaInicio > fechaFin) {
            mostrarToast('La fecha de inicio no puede ser mayor a la fecha de fin.', 'warning');
            return;
        }

       
        const inputDestino = document.getElementById(this.config.idInicio);
        const panelParametros = inputDestino ? inputDestino.closest('.collapse') : null;

        if (panelParametros && window.bootstrap && bootstrap.Collapse) {
            const collapseInstancia = bootstrap.Collapse.getInstance(panelParametros) || 
                                     new bootstrap.Collapse(panelParametros, { toggle: false });
            collapseInstancia.hide(); // Contrae el menú de parámetros con animación nativa
        }

        localStorage.setItem(this.config.storageKey, JSON.stringify({
            fechaInicio: fechaInicioStr,
            fechaFin: fechaFinStr,
            metricas: metricasSeleccionadas
        }));

        this.dibujarGraficaPorRango(metricasSeleccionadas, fechaInicio, fechaFin);
    }

    dibujarGraficaPorRango(metricas, fInicio, fFin) {
        const elCanvas = document.getElementById(this.config.idCanvas);
        if (!elCanvas) return;
        
        const ctx = elCanvas.getContext('2d');
        const mesesNombres = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
        const mesesCortos = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

        let etiquetas = [];
        let periodos = [];
        let fActual = new Date(fInicio);

        while (fActual <= fFin) {
            const mesIndex = fActual.getMonth();
            const anio = fActual.getFullYear();
            etiquetas.push(`${mesesCortos[mesIndex]}-${anio}`);
            periodos.push({ mesNombre: mesesNombres[mesIndex], anio: anio });
            
            fActual.setMonth(fActual.getMonth() + 1);
        }

/*        const datasets = metricas.map((metrica, idx) => {
            const valores = periodos.map(p => {
                const fila = this.datosGlobales.find(d => d.nombre_campo === metrica && d.anio == p.anio);
                if (!fila) return null;

                const claveMesReal = Object.keys(fila).find(key => key.toLowerCase() === p.mesNombre.toLowerCase());
                return claveMesReal ? parseFloat(fila[claveMesReal]) : null;
            });

            const color = ['#FF6384', '#36A2EB', '#4BC0C0', '#FF9F40', '#9966FF', '#FFB6C1', '#87CEFA', '#B0E0E6', '#FFD700', '#D8BFD8', '#98FB98', '#FFDAB9', '#E6E6FA', '#FFFACD', '#F08080'][idx % 15];
            return {
                label: metrica,
                data: valores,
                borderColor: color,
                backgroundColor: color,
                tension: 0.3,
                spanGaps: true
            };
        });*/

        const datasets = metricas.map((metrica, idx) => {

    const valores = periodos.map(p => {

        const fila =
            this.datosGlobales.find(
                d =>
                    d.nombre_campo === metrica &&
                    d.anio == p.anio
            );

        if (!fila) return null;

        const claveMesReal =
            Object.keys(fila).find(
                key =>
                    key.toLowerCase() ===
                    p.mesNombre.toLowerCase()
            );

        return claveMesReal
            ? parseFloat(fila[claveMesReal])
            : null;
    });


    const color =
        generarColor(
            idx,
            metricas.length
        );


    return {
        label: metrica,
        data: valores,
        borderColor: color,
        backgroundColor: color,
        tension: 0.3,
        spanGaps: true
    };

});
function generarColor(index, total) {

    const hue =
        Math.round(
            (360 / Math.max(total, 1)) * index
        );

    return `hsl(${hue}, 80%, 80%)`;
}

/**/
        if (this.GraficaInstance) {
            this.GraficaInstance.destroy();
        }

        this.GraficaInstance = new Chart(ctx, {
            type: 'line',
            data: {
                labels: etiquetas,
                datasets: datasets
            },

            options: {
                responsive: true,
                maintainAspectRatio: false,
        
                plugins: {
                    legend: {
                        display: true,
                        position: this.config.posicionLeyenda,
        
                        onClick: (event, legendItem, legend) => {
                            const chart = legend.chart;
                            const index = legendItem.datasetIndex;
                            chart.setDatasetVisibility(
                                index,
                                !chart.isDatasetVisible(index)
                            );
            
                            chart.update();
                            if (this.config.onLegendChange) {
                                this.config.onLegendChange(chart);
                            }
                        }
                    }
                },

                scales: {
                    x: {
                        ticks: {
                            maxRotation: 45,
                            minRotation: 45
                        }
                        }
                    }
                }
            });
    }
}
